var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShortlistActive = function SvgShortlistActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 231.46h-49.91v-50.92a18.66 18.66 0 1 0-37.31 1v49.92h-49.91a18.65 18.65 0 1 0 0 37.29h49.91v49.85a18.66 18.66 0 0 0 37.31 0v-49.91h49.91v.06a18.65 18.65 0 1 0 0-37.29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M470.59 250c0-121.83-98.76-220.59-220.59-220.59S29.41 128.17 29.41 250 128.17 470.59 250 470.59h7.35c117.77 0 213.24-95.47 213.24-213.24zM250 394.12A144.12 144.12 0 1 1 394.12 250 144.13 144.13 0 0 1 250 394.12"
  })));
};
export default SvgShortlistActive;